import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TuningsService, Tuning } from '../LIB/services/tunings.service';
import { NotesService } from '../LIB/services/notes.service';
import { OptionsService } from '../services/options.service';

@Component({
  selector: 'app-fretboard',
  templateUrl: './fretboard.page.html',
  styleUrls: ['./fretboard.page.scss'],
})
export class FretboardPage implements OnInit {
  public custom = false;
  public currentChapterAndIndex = '';
  public tuning: Tuning;
  public tuningIndex: number;
  public CSValue = {note12: -1, name: '', type: ''};
  public CS: string[] = [
    'Major chord',
    'Minor chord',
    '7 chord',
    'Minor 7 chord',
    'maj7 chord',
    'Major scale',
    'Minor scale',
    'Maj. penta. scale',
    'Min. penta. scale'
  ];
  public defaultSelectedCS = 5;
  public CSValues: {name: string, type: string}[] = [
    {name: 'major', type: 'chord'},
    {name: 'minor', type: 'chord'},
    {name: ' 7', type: 'chord'},
    {name: 'm7', type: 'chord'},
    {name: 'maj7', type: 'chord'},
    {name: 'major ', type: 'scale'},
    {name: 'minor (natural)', type: 'scale'},
    {name: 'pentatonic major', type: 'scale'},
    {name: 'pentatonic minor', type: 'scale'}
  ];
  public selectedNote12String = '';
  public selectedCSIndexString = '';

  constructor(
    public route: ActivatedRoute,
    public notesService: NotesService,
    public tuningsService: TuningsService,
    public opt: OptionsService 
  ) { }

  ngOnInit() {
    this.custom = (this.route.snapshot.params.id.substr(0, 9) === 'customize');
    this.currentChapterAndIndex = this.route.snapshot.params.id.replace('customize', '');
    this.setTuningFromChapterAndIndex();
    this.initFretboard();
  }
  setTuningFromChapterAndIndex() {
    if (this.currentChapterAndIndex === '') {
      this.tuning = this.tuningsService.standard[0];
    } else {
      const chapter = parseInt(this.currentChapterAndIndex.split('.')[0], 10);
      this.tuningIndex = parseInt(this.currentChapterAndIndex.split('.')[1], 10);
      this.tuning = this.tuningsService.chapters[chapter].tunings[this.tuningIndex];
    }
  }
  initFretboard() {
    const currentTuning = this.tuning;
    this.selectedNote12String = '';
    this.selectedCSIndexString = '';
    if (currentTuning.hasOwnProperty('preferredNote12') &&
        (currentTuning.preferredNote12 !== -1)) {
      this.selectedNote12String = currentTuning.preferredNote12.toString();
      if (currentTuning.preferredChord === 'm') {
        this.selectedCSIndexString = '1';
      } else if (currentTuning.preferredChord === '7') {
        this.selectedCSIndexString = '2';
      } else if (currentTuning.preferredChord === 'm7') {
        this.selectedCSIndexString = '3';
      } else if (currentTuning.preferredScale === 'major') {
        this.selectedCSIndexString = '5';
      } else if (currentTuning.preferredScale === 'minor') {
        this.selectedCSIndexString = '6';
      } else if (currentTuning.preferredScale !== 'none') {
        this.selectedCSIndexString = this.defaultSelectedCS.toString();
      }
    }
    this.refreshFretboard();
  }
  refreshFretboard() {
    if (
      (!this.selectedNote12String) ||
      (!this.selectedCSIndexString)) {
      this.CSValue = {note12: -1, name: '', type: ''};
    } else {
      this.CSValue = {
        type: this.CSValues[parseInt(this.selectedCSIndexString, 10)].type,
        name: this.CSValues[parseInt(this.selectedCSIndexString, 10)].name,
        note12: parseInt(this.selectedNote12String, 10)
      };
    }
  }
  reset() {
    this.selectedNote12String = '';
    this.selectedCSIndexString = '';
    this.refreshFretboard();
  }
  showReset(): boolean {
    return !(
      (!this.selectedNote12String) ||
      (this.selectedNote12String === '') ||
      (!this.selectedCSIndexString) ||
      (this.selectedCSIndexString === '')
    );
  }
}
